import {
    getIndustriesList,
    addSingleIndustry,
    deleteSingleIndustry,
    GetIndustriesListResponse,
    AddIndustryRequest,
    getSingleIndustry,
    updateSingleIndustry,
    getIndustryOrganizationsList
} from '@/modules/industries/api'
import { computed, ref } from 'vue'

const industries = ref<GetIndustriesListResponse>([])

const getIndustries = () => getIndustriesList().then(industriesList => {
    industries.value = industriesList.map(industry => {
        return {
            id: industry.id.toString(),
            name: industry.name
        }
    })
})

const addIndustry = (payload: AddIndustryRequest) => addSingleIndustry(payload).then(getIndustries)

const updateIndustry = (id: string, payload: AddIndustryRequest) => updateSingleIndustry(id, payload).then(getIndustries)

const deleteIndustry = (id: string) => deleteSingleIndustry(id).then(getIndustries)

const getIndustryOrganizations = (id: string) => getIndustryOrganizationsList(id).then(industryOrganizationsList => {
    return industryOrganizationsList.map(organization => {
        return {
            id: organization.id.toString(),
            name: organization.companyName
        }
    })
})

export function useIndustryModule () {
    return {
        getIndustries,
        industries: computed(() => industries.value),
        addIndustry,
        getSingleIndustry,
        updateIndustry,
        deleteIndustry,
        getIndustryOrganizations
    }
}
